import { StringUtils } from '../utils/siteUtils'

import { useEdgeDataFetcherYMM } from './useEdgeDataFetcher'

export default (location, pageContext, offer) => {
  const vehicle = offer && offer.prospect && offer.prospect.vehicle
  const { yearId, makeId, modelId } = vehicle || {}

  const { params } = StringUtils.getPathParameters(location ? location.pathname : '')
  const [yearParam, makeParam, modelParam] = params

  const { year: yearQuery, make: makeQueryParam, makemodel, model: modelQuery1 } = location ? location.initQueryParams : {}
  const makeQuery1 = (makeQueryParam && makeQueryParam.toLowerCase()) || (makemodel && makemodel.toLowerCase())
  const makeQuery = makeQuery1 && makeQuery1.replace(/\+/g, '-')
  const modelQuery = modelQuery1 && modelQuery1.replace(/\+/g, '-').toLowerCase()

  const yearSelect = yearParam ? yearParam : yearQuery ? yearQuery : yearId
  const makeSelect = makeParam ? makeParam : makeQuery ? makeQuery : makeId
  const modelSelect = modelParam ? modelParam : modelQuery ? modelQuery : modelId

  const inPath = !!yearParam || !!yearQuery //select from Id //added yearQuery since location was not updating yearParam correctly

  const { year, make, model } = (location && location.state) || {}
  const ymmContext = useEdgeDataFetcherYMM(pageContext, yearSelect, makeSelect, modelSelect, inPath)
  if (year) ymmContext.year = year
  if (make) ymmContext.make = make
  if (model) ymmContext.model = model

  return { ymmContext, yearParam, yearQuery, makeQuery, modelQuery }
}
